import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { richiestaStream } from "../lib/richiesta_stream"

// TracciaSpese di components/TracciaSpese.js (31a5bd1): le spunte (spunte, nell'ordine in cui si mettono), «Seleziona
// le categorie spuntate» attivo con almeno una spunta, «Aggiungi un'altra voce» per una riga che ha già la sua voce.
// invia(): POST JSON a urlValue ({ righe } o { ancora: [id] }) con i pulsanti disattivati e la rotella (busy); la
// risposta è il turbo-stream con il toast, la traccia riscritta (questo elemento sostituito, le spunte azzerate come
// setSpunte([])) e la pagina riletta. Un errore lascia le spunte: il toast arriva nel turbo-stream, o è il `detail`
// della risposta, o «Non riuscito»; un rinvio (sessione scaduta, verifica in due passaggi) apre la sua pagina.
export default class extends Controller {
  static targets = ["seleziona", "altra", "attesa"]
  static values = { url: String }

  connect() {
    this.spunte = []
    this.busy = false
  }

  spunta(event) {
    const id = event.target.value
    this.spunte = this.spunte.includes(id) ? this.spunte.filter((x) => x !== id) : [...this.spunte, id]
    this.aggiorna()
  }

  seleziona() {
    this.invia({ righe: [...this.spunte] })
  }

  // l'id della riga dal suo attributo (un parametro di Stimulus di sole cifre diventerebbe un numero)
  altra(event) {
    this.invia({ ancora: [event.currentTarget.dataset.riga] })
  }

  aggiorna() {
    if (this.hasSelezionaTarget) this.selezionaTarget.disabled = this.busy || this.spunte.length === 0
    this.altraTargets.forEach((b) => { b.disabled = this.busy })
    if (this.hasAttesaTarget) this.attesaTarget.toggleAttribute("hidden", !this.busy)
  }

  async invia(corpo) {
    if (this.busy) return
    this.busy = true
    this.aggiorna()
    try {
      const r = await richiestaStream(this.urlValue, { corpo })
      if (r) Turbo.renderStreamMessage(r.testo)
    } finally {
      this.busy = false
      if (this.element.isConnected) this.aggiorna()
    }
  }
}
